import {useIsNavigatingOrPending} from '../../../support/use_is_navigating_or_pending';
import {Button} from '../../../components/button/button';
import {__} from '../../../support/lang/translations';
import {ButtonColorType} from '../../../enums/button_color_type.ts';
import buttonStyles from '../../../components/button/button.module.scss';

export function PrivacyAgreementTitle() {
    return (
        <>
            <h1>{__('onboarding.privacy_agreement.title')}</h1>
            <p>{__('onboarding.privacy_agreement.subtitle')}</p>
        </>
    );
}

export function PrivacyAgreementContent() {
    return (
        <>
            <h2>{__('onboarding.privacy_agreement.content_title')}</h2>
            <p>{__('onboarding.privacy_agreement.content_explanation')}</p>
        </>
    );
}

interface FooterProps {
    onDisagree: () => void;
}
export function PrivacyAgreementFooter(props: FooterProps) {
    const isLoading = useIsNavigatingOrPending((state) => state.customerInfo.status);

    return (
        <>
            <div>
                <Button
                    className={buttonStyles.button_step}
                    disabled={isLoading}
                    type="button"
                    onClick={() => props.onDisagree()}
                >
                    <i className="fa-light fa-x" />
                    <span>{__('onboarding.privacy_agreement.buttons.disagree')}</span>
                </Button>
            </div>
            <div>
                <Button
                    className={buttonStyles.button_step}
                    disabled={isLoading}
                    type="submit"
                    colorType={ButtonColorType.Green}
                >
                    <i className="fa-light fa-check" />
                    <span>{__('onboarding.privacy_agreement.buttons.agree')}</span>
                </Button>
            </div>
        </>
    );
}
